module.exports = __webpack_public_path__ + "2df539f4215e33a651545696ccb5dd64.svg";